import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { FC } from 'react';

export const MembersFeatureFlagsDialogSkeleton: FC = () => {
  return (
    <Stack spacing={1}>
      {Array.from({ length: 4 }).map((_, index) => (
        // oxlint-disable-next-line react/no-array-index-key
        <Box key={index} display="flex" alignItems="center" gap={2} sx={{ py: 1 }}>
          <Box flex={1} minWidth={0}>
            <Skeleton variant="text" width="40%" height={22} />
            <Skeleton variant="text" width="70%" height={16} />
          </Box>
          <Skeleton variant="rectangular" width={44} height={24} sx={{ borderRadius: 12 }} />
        </Box>
      ))}
    </Stack>
  );
};
